export const validarDescricao = (descricao: string): boolean => {
    const descricaoSanitizada = sanitizeInput(descricao);
    return descricaoSanitizada.length <= 100;
};

export const validarUnidade = (unidade: string): boolean => {
    const unidadeSanitizada = sanitizeInput(unidade);
    return unidadeSanitizada.length <= 100;
};

export const validarLugar = (lugar: string): boolean => {
    const lugarSanitizado = sanitizeInput(lugar);
    return lugarSanitizado.length <= 100;
};

function sanitizeInput(input: string): string {
    const trimmedInput = input.trim();
    return trimmedInput.replace(/['";]+/g, '');
}
